module.exports = __webpack_public_path__ + "static/img/MGVAGVTechnical.60d44bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/MGVAGVTechnical.png
// module id = rVcT
// module chunks = 1